module.exports = __webpack_public_path__ + "static/media/appGuide.72468b05.webp";